module.exports = "/_next/static/media/3991fb1c92993a8692ef0d86495baa87.svg";